"use strict";
/**
 * This code was GENERATED using the solita package.
 * Please DO NOT EDIT THIS FILE, instead rerun solita to update it or write a wrapper to add functionality.
 *
 * See: https://github.com/metaplex-foundation/solita
 */
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.createInitPolicyInstruction = exports.initPolicyInstructionDiscriminator = exports.initPolicyStruct = void 0;
const beet = __importStar(require("@metaplex-foundation/beet"));
const web3 = __importStar(require("@solana/web3.js"));
const InitPolicyArg_1 = require("../types/InitPolicyArg");
/**
 * @category Instructions
 * @category InitPolicy
 * @category generated
 */
exports.initPolicyStruct = new beet.FixableBeetArgsStruct([
    ['instructionDiscriminator', beet.uniformFixedSizeArray(beet.u8, 8)],
    ['arg', InitPolicyArg_1.initPolicyArgBeet],
], 'InitPolicyInstructionArgs');
exports.initPolicyInstructionDiscriminator = [
    45, 234, 110, 100, 209, 146, 191, 86,
];
/**
 * Creates a _InitPolicy_ instruction.
 *
 * @param accounts that will be accessed while the instruction is processed
 * @param args to provide as instruction data to the program
 *
 * @category Instructions
 * @category InitPolicy
 * @category generated
 */
function createInitPolicyInstruction(accounts, args, programId = new web3.PublicKey('ocp4vWUzA2z2XMYJ3QhM9vWdyoyoQwAFJhRdVTbvo9E')) {
    const [data] = exports.initPolicyStruct.serialize({
        instructionDiscriminator: exports.initPolicyInstructionDiscriminator,
        ...args,
    });
    const keys = [
        {
            pubkey: accounts.policy,
            isWritable: true,
            isSigner: false,
        },
        {
            pubkey: accounts.uuid,
            isWritable: false,
            isSigner: false,
        },
        {
            pubkey: accounts.authority,
            isWritable: true,
            isSigner: true,
        },
        {
            pubkey: accounts.systemProgram ?? web3.SystemProgram.programId,
            isWritable: false,
            isSigner: false,
        },
    ];
    const ix = new web3.TransactionInstruction({
        programId,
        keys,
        data,
    });
    return ix;
}
exports.createInitPolicyInstruction = createInitPolicyInstruction;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiaW5pdFBvbGljeS5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uLy4uLy4uLy4uL3NyYy9nZW5lcmF0ZWQvaW5zdHJ1Y3Rpb25zL2luaXRQb2xpY3kudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IjtBQUFBOzs7OztHQUtHOzs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7OztBQUVILGdFQUFpRDtBQUNqRCxzREFBdUM7QUFDdkMsMERBQXlFO0FBVXpFOzs7O0dBSUc7QUFDVSxRQUFBLGdCQUFnQixHQUFHLElBQUksSUFBSSxDQUFDLHFCQUFxQixDQUs1RDtJQUNFLENBQUMsMEJBQTBCLEVBQUUsSUFBSSxDQUFDLHFCQUFxQixDQUFDLElBQUksQ0FBQyxFQUFFLEVBQUUsQ0FBQyxDQUFDLENBQUM7SUFDcEUsQ0FBQyxLQUFLLEVBQUUsaUNBQWlCLENBQUM7Q0FDM0IsRUFDRCwyQkFBMkIsQ0FDNUIsQ0FBQTtBQWtCWSxRQUFBLGtDQUFrQyxHQUFHO0lBQ2hELEVBQUUsRUFBRSxHQUFHLEVBQUUsR0FBRyxFQUFFLEdBQUcsRUFBRSxHQUFHLEVBQUUsR0FBRyxFQUFFLEdBQUcsRUFBRSxFQUFFO0NBQ3JDLENBQUE7QUFFRDs7Ozs7Ozs7O0dBU0c7QUFDSCxTQUFnQiwyQkFBMkIsQ0FDekMsUUFBdUMsRUFDdkMsSUFBK0IsRUFDL0IsU0FBUyxHQUFHLElBQUksSUFBSSxDQUFDLFNBQVMsQ0FBQyw2Q0FBNkMsQ0FBQztJQUU3RSxNQUFNLENBQUMsSUFBSSxDQUFDLEdBQUcsd0JBQWdCLENBQUMsU0FBUyxDQUFDO1FBQ3hDLHdCQUF3QixFQUFFLDBDQUFrQztRQUM1RCxHQUFHLElBQUk7S0FDUixDQUFDLENBQUE7SUFDRixNQUFNLElBQUksR0FBdUI7UUFDL0I7WUFDRSxNQUFNLEVBQUUsUUFBUSxDQUFDLE1BQU07WUFDdkIsVUFBVSxFQUFFLElBQUk7WUFDaEIsUUFBUSxFQUFFLEtBQUs7U0FDaEI7UUFDRDtZQUNFLE1BQU0sRUFBRSxRQUFRLENBQUMsSUFBSTtZQUNyQixVQUFVLEVBQUUsS0FBSztZQUNqQixRQUFRLEVBQUUsS0FBSztTQUNoQjtRQUNEO1lBQ0UsTUFBTSxFQUFFLFFBQVEsQ0FBQyxTQUFTO1lBQzFCLFVBQVUsRUFBRSxJQUFJO1lBQ2hCLFFBQVEsRUFBRSxJQUFJO1NBQ2Y7UUFDRDtZQUNFLE1BQU0sRUFBRSxRQUFRLENBQUMsYUFBYSxJQUFJLElBQUksQ0FBQyxhQUFhLENBQUMsU0FBUztZQUM5RCxVQUFVLEVBQUUsS0FBSztZQUNqQixRQUFRLEVBQUUsS0FBSztTQUNoQjtLQUNGLENBQUE7SUFFRCxNQUFNLEVBQUUsR0FBRyxJQUFJLElBQUksQ0FBQyxzQkFBc0IsQ0FBQztRQUN6QyxTQUFTO1FBQ1QsSUFBSTtRQUNKLElBQUk7S0FDTCxDQUFDLENBQUE7SUFDRixPQUFPLEVBQUUsQ0FBQTtBQUNYLENBQUM7QUF0Q0Qsa0VBc0NDIn0=